import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { EmptyStateComponent } from '@tecalisdev/infinity';
import { IOperationDetailResponse, OPERATION_TYPE } from '../../../models/operations.models';
import { OperationDetailTabsChecksOcrComponent } from './operation-detail-tabs-checks-ocr/operation-detail-tabs-checks-ocr.component';
import { OperationDetailTabsChecksPolComponent } from './operation-detail-tabs-checks-pol/operation-detail-tabs-checks-pol.component';
import { OperationDetailTabsChecksDocumentsComponent } from './operation-detail-tabs-checks-documents/operation-detail-tabs-checks-documents.component';
import { OperationDetailTabsChecksFinancialEvaluationComponent } from './operation-detail-tabs-checks-financial-evaluation/operation-detail-tabs-checks-financial-evaluation.component';
import { OperationDetailTabsChecksBormeComponent } from './operation-detail-tabs-checks-borme/operation-detail-tabs-checks-borme.component';
import { OperationDetailTabsChecksFormComponent } from './operation-detail-tabs-checks-form/operation-detail-tabs-checks-form.component';

@Component({
	selector: 'app-operation-detail-tabs-checks',
	imports: [
		TranslatePipe,
		EmptyStateComponent,
		OperationDetailTabsChecksOcrComponent,
		OperationDetailTabsChecksPolComponent,
		OperationDetailTabsChecksDocumentsComponent,
		OperationDetailTabsChecksFinancialEvaluationComponent,
		OperationDetailTabsChecksBormeComponent,
		OperationDetailTabsChecksFormComponent,
	],
	templateUrl: './operation-detail-tabs-checks.component.html',
	styleUrl: './operation-detail-tabs-checks.component.scss',
})
export class OperationDetailTabsChecksComponent {
	@Input() detail: IOperationDetailResponse;

	public OPERATION_TYPE = OPERATION_TYPE;
}
